import { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { getSites } from 'api/canvms';
import { displayErrorMessage } from 'redux/notificationBar/notificationBarSlice';
import { VMSSite } from '../types/canvision.types';

export function useSites() {
  const dispatch = useDispatch();
  const [sites, setSites] = useState<VMSSite[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const initialLoadDone = useRef(false);

  const fetchSites = useCallback(async (isRefresh = false) => {
    try {
      // Only show loading on initial load, not refreshes
      if (!isRefresh && !initialLoadDone.current) {
        setLoading(true);
      }
      setError(null);
      const response = await getSites();
      setSites(response.data?.sites || []);
      initialLoadDone.current = true;
    } catch (err: any) {
      const message = err.response?.data?.message || err.message || 'Failed to fetch sites';
      console.error('[CANVMS/fetchSites] Error fetching sites:', err);
      setError(message);
      dispatch(displayErrorMessage(message));
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchSites(false);
  }, [fetchSites]);

  const refetch = useCallback(() => fetchSites(true), [fetchSites]);

  return { sites, loading, error, refetch };
}
